import { render, staticRenderFns } from "./adminListComponent.vue?vue&type=template&id=1f01496c&scoped=true&"
import script from "./adminListComponent.vue?vue&type=script&lang=js&"
export * from "./adminListComponent.vue?vue&type=script&lang=js&"
import style0 from "./adminListComponent.vue?vue&type=style&index=0&id=1f01496c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f01496c",
  null
  
)

export default component.exports